import facebookPixelAgent from './facebook/agent';
import googleAnalyticsAgent from './google/agent';
import googleTagManagerAgent from './googleTagManager/agent';
import kakaoPixelAgent from './kakaoPixel/agent';

export default {
  facebook: facebookPixelAgent,
  ga: googleAnalyticsAgent,
  gtm: googleTagManagerAgent,
  kakaoPixel: kakaoPixelAgent,
};
